import { post, get } from "../Https";

// get template prescriptions List
export const templatePrescriptionList = (params: any) => {
  return get("/drx/api/template/prescription/list.do?" + params);
};

// for creating a new template
export const createNewTemplate = (data: any) => {
  return post("/drx/api/template/prescription/create.do", data);
};

// add new medication into the template
export const addMedicationsToTemplate = (data: any) => {
  return post(
    "/drx/api/template/prescription/addmedicationtotemplate.do",
    data
  );
};

// template prescription drug remove
export const templatePrescriptionRemoveDrug = (data: any) => {
  return post("/drx/api/template/prescription/remove/drug.do", data);
};

// template medications list
export const templateMedicationsList = (params: any) => {
  return get("/drx/api/template/prescription/list/medications.do?" + params);
};

// confirm template
export const confirmTemplateMed = (data: any) => {
  return post("/drx/api/template/prescription/confirm.do", data);
};

//delete template
export const deleteTemplate = (params: any) => {
  return get("/drx/api/template/prescription/delete.do?" + params);
};

//edit template
export const editTemplate = (data: any) => {
  return post("/drx/api/template/prescription/edit.do", data);
};
